const mutations = {
    SET_MENU(state, menu) {state.menu = menu;},
};

export default mutations

